import { ScrollArea } from "@mantine/core";
import { useViewportSize } from "@mantine/hooks";
import { ReactNode } from "react";

export function DesktopView({
  sideBar,
  mainContent,
}: {
  sideBar: ReactNode;
  mainContent: ReactNode;
}) {
  const { height } = useViewportSize();

  return (
    <div className="relative grid grid-cols-1 sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 md:gap-x-4 gap-y-4">
      <div className="col-span-1 relative">
        <div
          style={{
            top: "4.75rem",
          }}
          className="sticky"
        >
          <ScrollArea
            h={height - 140}
            scrollbarSize={4}
            scrollbars="y"
            type="hover"
            offsetScrollbars={true}
          >
            {sideBar}
          </ScrollArea>
        </div>
      </div>
      <div className="col-span-1 sm:col-span-1 md:col-span-2 lg:col-span-2 xl:col-span-3 2xl:col-span-4">
        {mainContent}
      </div>
    </div>
  );
}
